import React from 'react'
import { useTranslation } from 'react-i18next'
import { EventTypes } from 'types/events'
import Input from 'components/Input'
import Submit from 'components/fields/Submit'
import ScheduledAt from 'components/ScheduledAt'
import Margin from 'components/Margin'
import { isRequired } from 'utils/validators'
import { CallTypes } from 'types/callstore'
import { useSelector } from 'react-redux'
import { selectFormsState } from 'redux/appStore'
import { BreakdownDetailsForm, BreakdownNote } from '../BreakdownDetails'
import { BreakdownOptions } from '../BreakdownDetails/BreakdownRadio'
import { useGetProviderCounts } from 'hooks/universalPayload/useGetProviderCounts'
import { useCreateSoftDispatchService } from 'hooks/dispatch/useSoftDispatch'

function LockoutDispatch() {
  const { t } = useTranslation()
  const { lockout } = useSelector(selectFormsState) as any
  const { providerCount, providersLoading: loading } = useGetProviderCounts()
  const [providersLoading, setProvidersLoading] = React.useState<boolean>(false)
  const createSoftDispatchService = useCreateSoftDispatchService(EventTypes.LOCKOUT, providerCount)

  React.useEffect(() => {
    if (loading) setProvidersLoading(true)
    else setProvidersLoading(false)
  }, [loading])

  let safeToContinue =
    (lockout?.breakdownOption === BreakdownOptions.ROADWAYINTERSTATE && lockout?.unsafe === 'no') ||
    (lockout?.breakdownOption === BreakdownOptions.PARKINGGARAGE && lockout?.garageAccessible === 'yes') ||
    (lockout?.breakdownOption === BreakdownOptions.OTHER && lockout?.accessible === 'yes')

  return (
    <>
      <BreakdownDetailsForm callType={CallTypes.KEYS} />
      {safeToContinue && (
        <>
          <Margin spacing="md">
            <ScheduledAt callType={CallTypes.KEYS} />
            <Input.Hidden name="scheduledAt" />
          </Margin>
          <BreakdownNote
            breakdownOption={lockout?.breakdownOption}
            unsafe={lockout?.unsafe}
            garageAccessible={lockout?.garageAccessible}
            accessible={lockout?.accessible}
          />
          <Input.Textarea
            label={`${t('notesToProvider.label')}*`}
            placeholder={t('notesToProvider.placeholder')}
            name="notes"
            maxLength={240}
            validate={isRequired(t('required.notes'))}
          />
          <Margin spacing="md">
            <Submit externalLoading={providersLoading} onSubmit={createSoftDispatchService}>
              {t('lockout.dispatch')}
            </Submit>
          </Margin>
        </>
      )}
    </>
  )
}

export default LockoutDispatch
